import config from '../../../config';
import { SEARCH_RESULT_CATEGORY_ID } from '../../../model/constants';
import { LogicContext } from '../types';
import { groupItemsByTypes, mapGamesWithJackpotsV2 } from '../utils';

export const getSearchItemsContent = async (context: LogicContext) => {
  const { searchItems, currentType } = context.search;
  const gamesWithJackpotV2 = mapGamesWithJackpotsV2(
    searchItems,
    context.currentJackpotsV2
  );
  const groupedItems = groupItemsByTypes(gamesWithJackpotV2);
  const locale = config.locale;
  const currency = context.user?.currency || config.default_currency;
  const { loggedIn } = context.user;
  const searchResultCategory = {
    id: SEARCH_RESULT_CATEGORY_ID,
    title: `Search Results`,
    games: groupedItems[currentType],
  };

  return {
    updates: [
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.SearchResult.properties`,
          value: {
            category: searchResultCategory,
            locale,
            currency,
            loggedIn,
            callbackMode: context.callbackMode,
          },
        },
      },
    ],
  };
};
